import {utils} from 'ethers';
import {computed, makeAutoObservable, observable} from 'mobx';
import {tokenDecimals} from '../helpers/config/contracts.config';
import {removeTrailingZeros} from '../helpers/formatters';

export const convertNrsBalanceToDecimal = (balance: string) => {
    return removeTrailingZeros(utils.formatUnits(balance, tokenDecimals.nrs));
}

class LockBalanceStore {
    latestUpdateAt = 0;
    nrsTokenBalance = '0';
    nrsAvailableBalance = '0';

    get nrsAvailableBalanceDecimal() {
        return convertNrsBalanceToDecimal(this.nrsAvailableBalance);
    }
    get nrsTokenBalanceDecimal() {
        return convertNrsBalanceToDecimal(this.nrsTokenBalance);
    }

    constructor() {
        makeAutoObservable(this, {
            nrsAvailableBalance: observable,
            nrsTokenBalance: observable,
            nrsAvailableBalanceDecimal: computed,
            nrsTokenBalanceDecimal: computed,
        });
    }

    public setNrsAvailableBalance(newBalance: string) {
        this.nrsAvailableBalance = newBalance;
    }

    public resetState() {
        this.nrsTokenBalance = '0';
        this.nrsAvailableBalance = '0';
    }

    setNrsTokenBalanceDecimal(newBalance: string) {
        this.nrsTokenBalance = newBalance;
    }

    async fetchBalances(nrsContract: any, lockNrsContract: any, address: string) {
        this.latestUpdateAt = Date.now()
        {
            const balance = await nrsContract.read.balanceOf([address]);
            this.setNrsTokenBalanceDecimal(balance.toString());
        }
        {
            const balance = await lockNrsContract.read.maxWithdraw([address]);
            this.setNrsAvailableBalance(balance.toString());
        }
    }

    async fetchBalancesThrottled(nrsContract: any, lockNrsContract: any, address: string) {
        if (this.latestUpdateAt === 0 || Date.now() - this.latestUpdateAt > 7000) {
            await this.fetchBalances(nrsContract, lockNrsContract, address)
        }
    }

}

export const lockBalanceStore = new LockBalanceStore();
